import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { IStore } from "../../core/store/IStore";
import { Dispatch } from "redux";
import withOverlayConfiguration from "../../core/components/overlay/configuration/withOverlayConfiguration";
import UIManager from "../../core/components/ui/UiBuilder";
import PIXI from "pixi.js";
import { configGame } from "../../data/config";
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { isMobile } from "react-device-detect";
import { actions as autoplayActions } from "../../core/reducers/autoplayReducer";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";
import { actions as baseGameActions } from "../../core/reducers/baseGameReducer";
import { actions as asyncActions } from "../../core/reducers/asyncServerResponseReducer";
import { actions as winpresentationAction } from "../../core/reducers/winPresentationReducer";
import { actions as reelsActions } from "../../core/reducers/reelsStateReducer";
import { actions as gridsActions } from "../../core/reducers/gridStateReducer";
import { actions as reelgridActions } from "../../core/reducers/reelgridStateReducer";

interface IProps {
    [x: string]: any;


}

interface IStateToProps {


}

interface IDispatchToProps {
}

interface IState {
    [x: string]: any;
}

class OverlayGenericUI extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected overlayGenericUIContainer: _ReactPixi.IContainer | Ref<any>;
    protected ui_mode: string;
    protected displayUI: any;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            autoplayContentShow: true,
            buttonSelected: "",
            uiElements: [],
            lang: "en"
        }
        this.overlayGenericUIContainer = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }

        this.displayUI = this.props.child.filter(this.checkUiMode.bind(this));
    }

    //while first rendering, this method will check the mode first
    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    //when layout changes, this method will be called
    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        )
    }

    //this method will be called when a button gets clicked
    handleEvent = (e: any) => {

    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        return true;
    }


    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        if (this.props.showAutoplay || this.props.showSettingPanelUI) {
            //UIManager.getRef("common_autoBgImage").visible = true;
        }
    }

    render() {


        return (
            <UIManager id={"overlayGenericUIContainer"} name={"overlayGenericUIContainer"} type={"Container"}
                ref={i => this.overlayGenericUIContainer = i} app={this.app}>
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            app={this.app} configGame={this.props.configGame}
                            disabled={!i.interactive}
                            id={i.id} ClickHandler={this.handleEvent} {...i} />)
                }
            </UIManager>)
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'applicationState' | 'autoplayState' | 'desktopSettingPanelState'>): IStateToProps =>
    ({
        showAutoplay: state.autoplayState.showAutoplay,
        showSettingPanelUI: state.desktopSettingPanelState.showSettingPanel,

    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
        hideAutoplay: (): any => dispatch(autoplayActions.hideAutoplayUI()),
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        setAutoplay: (autoplayCount: number): any => dispatch(autoplayActions.setAutoplayCount(autoplayCount)),
        startAutoplay: (): any => dispatch(baseGameActions.startAutoplay()),
        setApplicationAutoplayCount: (autoplaycount: number): any => dispatch(baseGameActions.setApplicationAutoplayCount(autoplaycount)),
        getApplicationSpinResponse: (): any => dispatch(asyncActions.getApplicationSpinResponse()),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        stopWinPresentation: (): any => dispatch(winpresentationAction.stopWinPresentation()),
        resetReelState: (): any => dispatch(Number(configGame["SPIN_TYPE"]) === 0 && reelsActions.resetReelState() || Number(configGame["SPIN_TYPE"]) === 1 && gridsActions.resetReelState() || Number(configGame["SPIN_TYPE"]) === 2 && reelgridActions.resetReelState()),
        autoplayReset: (resetAutoplay: boolean): any => dispatch(autoplayActions.autoplayReset(resetAutoplay)),
        setValueOfNumberButton: (numberButtonValue: number): any => dispatch(autoplayActions.setValueOfNumberButton(numberButtonValue)),
        interactivityOfStartButton: (startButtonInteractivity: boolean): any => dispatch(autoplayActions.interactivityOfStartButton(startButtonInteractivity)),
    }))(withOverlayConfiguration(OverlayGenericUI)));